import { render, staticRenderFns } from "./ClientesConectaPantalla.vue?vue&type=template&id=292e99e8&"
import script from "./ClientesConectaPantalla.vue?vue&type=script&lang=ts&"
export * from "./ClientesConectaPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports